(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["404-slider"] && !Shopify.designMode) return;
  try {
    
  // Mobile slider
  const productSlider = document.querySelector('.error_slider__container');
  let productSliderInstance = {};
  const settingsSlider = {
    loop: true,
    slidesPerView: 2,
    spaceBetween: 12, 
    pagination: {
      el: '.error_slider__pagination',
    }
  }

  window.addEventListener('load', swiperOnLoadOrResize);
  window.addEventListener('resize', swiperOnLoadOrResize);

  function swiperOnLoadOrResize() {
    if (window.innerWidth > 768) {
      if (productSlider.classList.contains('swiper-initialized')) {
        productSliderInstance.destroy({
          deleteInstance: true,
          cleanStyles: true
        });
      }
    } else {
      if (!productSlider.classList.contains('swiper-initialized')) {
        productSliderInstance = new Swiper('.error_slider__container', settingsSlider);
      }
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-laboratories"] && !Shopify.designMode) return;
  try {
    
  // Mobile slider
  const productSlider = document.querySelector('.about-labs__container');
  let productSliderInstance = {};
  const settingsSlider = {
    loop: true,
    spaceBetween: 20,
    pagination: {
      el: '.about-labs__pagination',
    }
  }

  window.addEventListener('load', swiperOnLoadOrResize);
  window.addEventListener('resize', swiperOnLoadOrResize);

  function swiperOnLoadOrResize() {
    if (window.innerWidth > 768) {
      if (productSlider.classList.contains('swiper-initialized')) {
        productSliderInstance.destroy({
          deleteInstance: true,
          cleanStyles: true
        });
      }
    } else {
      if (!productSlider.classList.contains('swiper-initialized')) {
        productSliderInstance = new Swiper('.about-labs__container', settingsSlider);
      }
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  const announcementBarSlider = new Swiper('.announcement-bar', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-main"]) return;
  try {
    
    const shopTheArticle = new Swiper('.shop-the-article__products', {
      slidesPerView: 1,
      loop: false,
      spaceBetween: 10,
      autoplay: false,
      speed: 500,
      autoHeight: true,
      pagination: {
        el: '.shop-the-article__swiper-pagination',
        clickable: true,
      },
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-featured-posts-columns"] && !Shopify.designMode) return;
  try {
    
  const blogColumnsSlider = new Swiper('.blog-featured-posts-cols', {
    slidesPerView: 1.05,
    loop: false,
    spaceBetween: 0,
    autoplay: false,
    speed: 500,
    pagination: {
      el: '.blog-featured-posts-cols__swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2.25,
        spaceBetween: 0
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 0
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-featured-posts-grid"]) return;
  try {
    
  const ctaBlocksSlider = new Swiper('.curated-health-guide__items', {
    slidesPerView: 1.05,
    loop: false,
    spaceBetween: 20,
    autoplay: false,
    speed: 500,
    pagination: {
      el: '.curated-health-guide__swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1024:{
        slidesPerView: 3,
        spaceBetween: 50,
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-hero"] && !Shopify.designMode) return;
  try {
    
  const ctaBlocksSlider = new Swiper('.blog-featured-posts-blocks', {
    slidesPerView: 1,
    loop: false,
    spaceBetween: 0,
    autoplay: false,
    speed: 500,
    pagination: {
      el: '.blog-featured-posts-blocks__swiper-pagination'
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 0,
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cta-blocks"] && !Shopify.designMode) return;
  try {
    
  const ctaBlocksSlider = new Swiper('.cta-blocks', {
    slidesPerView: 1.05,
    loop: false,
    spaceBetween: 16,
    autoplay: false,
    speed: 500,
    pagination: {
      el: '.cta-blocks__swiper-pagination'
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 0
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-product-carousel"] && !Shopify.designMode) return;
  try {
    
    const productCarousel = new Swiper('.feature-product-carousel', {
      slidesPerView: 1,
      loop: false,
      spaceBetween: 10,
      autoplay: false,
      speed: 500,
      autoHeight: true,
      pagination: {
                el: ".feature-product-carousel__swiper-pagination",
                clickable: true,
            },
      navigation:  {
        nextEl: '.feature-product-carousel__next .swiper-button-next',
        prevEl: '.feature-product-carousel__prev .swiper-button-prev',
      },
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    

emailSubmit($('footer'));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["general-faq"] && !Shopify.designMode) return;
  try {
    
  const faqButtons = document.querySelectorAll('.pdp-faq__item-header');

  faqButtons.forEach(faqButton => {
    faqButton.addEventListener('click', event => {
      const parent = event.currentTarget.parentElement;
      const content = parent.querySelector('.pdp-faq__item-content');
      const activeDropdown = document.querySelector('.pdp-faq__item.active');

      if (!parent.classList.contains('active')) {
        if (activeDropdown) {
          const activeContent = activeDropdown.querySelector('.pdp-faq__item-content');

          activeDropdown.classList.remove('active');
          slideUp(activeContent, 300);
        }

        parent.classList.add('active');
        slideDown(content, 300);
      } else {
        parent.classList.remove('active');
        slideUp(content, 300);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Header
  const header = document.getElementById('shopify-section-header');
  const HIDE_HEADER_CLASS = 'is-scrolling-down';
  let lastScrollTop = 0;
  const scrollOffset = 0;
  const body = document.body;
  var headroom  = new Headroom(header, {
    onNotTop : function() {
      setTimeout(function() {
        header.classList.add('add-background');
      }, 400);
    },
    onTop : function() {
      header.classList.remove('add-background');
    }
  });
  headroom.init();

  if (header) {
    console.log('header', header);
    const hideHeaderOnScrollDown = () => {
      const scrollTop = window.scrollY;
      scrollTop > lastScrollTop ? body.classList.add(HIDE_HEADER_CLASS) : body.classList.remove(HIDE_HEADER_CLASS);
      lastScrollTop = scrollTop <= scrollOffset ? scrollOffset : scrollTop;
    }

    window.addEventListener('scroll', hideHeaderOnScrollDown)
  }

  // Search
  const openSearch = document.querySelectorAll('.js-open-search');
  const closeSearch = document.querySelectorAll('.js-close-search');
  const search = document.querySelector('.header__search');
  const menuDrawer = new MenuDrawer();

  openSearch.forEach( button => {
    button.addEventListener('click', () => {
      if ( button.classList.contains('menu-drawer-search')){
        search.classList.add('is-visible');
        menuDrawer.closeMenuDrawer();
      } else {
        if (search.classList.contains('is-visible')) {
          search.classList.remove('is-visible');
        } else {
          search.classList.add('is-visible');
        }
      }

      if( document.querySelector('.shopify-section .template-search')){
        document.querySelector('.shopify-section .template-search').classList.add('search-open')
      }
  })
});

  closeSearch.forEach( button => {
    button.addEventListener('click', () => {
      search.classList.remove('is-visible');

      if( document.querySelector('.shopify-section .template-search')){
        document.querySelector('.shopify-section .template-search').classList.remove('search-open')
      }
    })
  }) ;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
  const howItWorksSlider = new Swiper('.how-it-works__slider', {
    slidesPerView: 1.04,
    loop: false,
    spaceBetween: 12,
    autoplay: {
      delay: 4000
    },
    speed: 500,
    pagination: {
      el: '.how-it-works__swiper-pagination',
      clickable: true
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: false
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-favorites"] && !Shopify.designMode) return;
  try {
    
  const favoriteButtons = document.querySelectorAll('.ingredients-favorites__ingredient-header');

  favoriteButtons.forEach(favoriteButton => {
    favoriteButton.addEventListener('click', event => {
      if (window.innerWidth < 769) {
        const parent = event.currentTarget.parentElement;
        const content = parent.querySelector('.ingredients-favorites__ingredient-wrapper');
        const activeDropdown = document.querySelector('.ingredients-favorites__ingredient.active');

        if (!parent.classList.contains('active')) {
          if (activeDropdown) {
            const activeContent = activeDropdown.querySelector('.ingredients-favorites__ingredient-wrapper');

            activeDropdown.classList.remove('active');
            slideUp(activeContent, 300);
          }

          parent.classList.add('active');
          slideDown(content, 300);
        } else {
          parent.classList.remove('active');
          slideUp(content, 300);
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-formulas"] && !Shopify.designMode) return;
  try {
    
  const ingredientButtons = document.querySelectorAll('.ingredients-formulas__item-header');

  ingredientButtons.forEach(ingredientButton => {
    ingredientButton.addEventListener('click', event => {
      const parent = event.currentTarget.parentElement;
      const content = parent.querySelector('.ingredients-formulas__item-content');
      const activeDropdown = document.querySelector('.ingredients-formulas__item.active');

      if (!parent.classList.contains('active')) {
        if (activeDropdown) {
          const activeContent = activeDropdown.querySelector('.ingredients-formulas__item-content');

          activeDropdown.classList.remove('active');
          slideUp(activeContent, 300);
        }

        parent.classList.add('active');
        slideDown(content, 300);
      } else {
        parent.classList.remove('active');
        slideUp(content, 300);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-index"] && !Shopify.designMode) return;
  try {
    
  const indexButtons = document.querySelectorAll('.ingredients-index__nav-item');

  indexButtons.forEach(button => {
    button.addEventListener('click', event => {
      const tab = event.currentTarget.dataset.tab;
      const activeButton = document.querySelector('.ingredients-index__nav-item.active');
  
      activeButton.classList.remove('active');
      event.currentTarget.classList.add('active');

      document.querySelector('.ingredients-index__content-item.active').classList.remove('active');
      document.querySelector(`.ingredients-index__content-item[data-tab="${tab}"]`).classList.add('active');
    })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Main product slider
  const initialSlide = Number(document.querySelector('.product__media-list').dataset.initial) - 1;
              
  // Product Slideshow
  const productSlider = new Swiper('.product__media-list', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    pagination: {
      el: '.product__media-pagination',
      clickable: true 
    },
    breakpoints: {
      768: {
        spaceBetween: 20
      }
    }
  });

  window.productSlider = productSlider;

  // Product thumbnails
  /* const productThumbnails = document.querySelectorAll('.product__thumbnail-item');
  productThumbnails.forEach(thumbnail => {
    thumbnail.addEventListener('click', event => {
      const idx = Number(event.currentTarget.dataset.idx);

      productSlider.slideToLoop(idx);
    });
  }); */

  // Product dropdowns
  const dropdownButtons = document.querySelectorAll('.product__dropdown-header');

  dropdownButtons.forEach(dropdownButton => {
    dropdownButton.addEventListener('click', event => {
      const parent = event.currentTarget.parentElement;
      const content = parent.querySelector('.product__dropdown-content');
      const activeDropdown = document.querySelector('.product__dropdown.active');

      if (!parent.classList.contains('active')) {
        if (activeDropdown) {
          const activeContent = activeDropdown.querySelector('.product__dropdown-content');

          activeDropdown.classList.remove('active');
          slideUp(activeContent, 300);
        }

        parent.classList.add('active');
        slideDown(content, 300);
      } else {
        parent.classList.remove('active');
        slideUp(content, 300);
      }
    });
  });

   // Show Modal
   const buttonSubscription = document.querySelector('.product-form__subscription-options-trigger button[data-micromodal-trigger]');
   buttonSubscription.addEventListener('click', event => {
    const parent = event.currentTarget.parentElement;
    const activeModal = document.querySelector('.subscription-pdp');
    const body = document.querySelector('body');
    parent.classList.toggle('active')
    if (!parent.classList.contains('active')) {
      activeModal.classList.remove('is-open');
      activeModal.setAttribute('aria-hidden', true)
      body.removeAttribute('style')
    } else {
      activeModal.classList.add('is-open');
      body.style.overflow= 'visible'
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-signup-bar"]) return;
  try {
    
emailSubmit($('footer'));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["numbered-blocks"] && !Shopify.designMode) return;
  try {
    

    const numberedBlocks = new Swiper('.numbered-blocks__mobile', {
      slidesPerView: 1,
      loop: false,
      spaceBetween: 20,
      autoplay: false,
      speed: 500,
      autoHeight: false,
      pagination: {
                el: ".numbered-blocks__mobile__swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.25,
                }
            }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-clinicals"] && !Shopify.designMode) return;
  try {
    
  const clinicalsSlider = new Swiper('.pdp-clinicals__slider', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    pagination: {
      el: '.pdp-clinicals__pagination'
    },
    breakpoints: {
      769: {
        
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-faq"] && !Shopify.designMode) return;
  try {
    
  const faqButtons = document.querySelectorAll('.pdp-faq__item-header');

  faqButtons.forEach(faqButton => {
    faqButton.addEventListener('click', event => {
      const parent = event.currentTarget.parentElement;
      const content = parent.querySelector('.pdp-faq__item-content');
      const activeDropdown = document.querySelector('.pdp-faq__item.active');

      if (!parent.classList.contains('active')) {
        if (activeDropdown) {
          const activeContent = activeDropdown.querySelector('.pdp-faq__item-content');

          activeDropdown.classList.remove('active');
          slideUp(activeContent, 300);
        }

        parent.classList.add('active');
        slideDown(content, 300);
      } else {
        parent.classList.remove('active');
        slideUp(content, 300);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-how-it-works"] && !Shopify.designMode) return;
  try {
    
  // Product Slideshow
  const productSlider = new Swiper('.product__media-list', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    breakpoints: {
      851: {
        
      }
    }
  });

  // Product dropdowns
  const dropdownButtons = document.querySelectorAll('.pdp-how__step-header');

  dropdownButtons.forEach(dropdownButton => {
    dropdownButton.addEventListener('click', event => {
      const parent = event.currentTarget.parentElement;
      const content = parent.querySelector('.pdp-how__step-content');
      const activeDropdown = document.querySelector('.pdp-how__step.active');

      if (!parent.classList.contains('active')) {
        if (activeDropdown) {
          const activeContent = activeDropdown.querySelector('.pdp-how__step-content');

          activeDropdown.classList.remove('active');
          slideUp(activeContent, 300);
        }

        parent.classList.add('active');
        slideDown(content, 300);
      } else {
        parent.classList.remove('active');
        slideUp(content, 300);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["standard-page-sections"]) return;
  try {
    
    const shopTheArticle = new Swiper('.shop-the-article__products', {
      slidesPerView: 1,
      loop: false,
      spaceBetween: 10,
      autoplay: false,
      speed: 500,
      autoHeight: true,
      pagination: {
        el: '.shop-the-article__swiper-pagination',
        clickable: true,
      },
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sustainability-plan"] && !Shopify.designMode) return;
  try {
    
  const planSlider = new Swiper('.sus-plan__mobile-container', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    speed: 500,
    pagination: {
      el: '.sus-plan .swiper-pagination'
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sustainability-projects"] && !Shopify.designMode) return;
  try {
    
  const sustainabilitySlider = new Swiper('.sus-projects__container', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    speed: 500,
    pagination: {
      el: '.sus-projects .swiper-pagination'
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  // Product Slideshow
  const productSlider = new Swiper('.product__media-list', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    breakpoints: {
      851: {
        
      }
    }
  });

  // Product dropdowns
  const dropdownButtons = document.querySelectorAll('.testimonials__item-header');

  dropdownButtons.forEach(dropdownButton => {
    dropdownButton.addEventListener('click', event => {
      const container = event.currentTarget.closest('.testimonials__content');
      const parent = event.currentTarget.parentElement;
      const testimonial_id = parent.dataset.testimonialId;
      const content = container.querySelector(`.testimonials__item-content[data-controlled-by="${testimonial_id}"]`);
      const activeContent = container.querySelector('.testimonials__item-content.active');
      const activeTrigger = container.querySelector('.testimonials__item.active');      

      //if the item clicked is already active, do nothing
      if (parent.classList.contains('active')) {
          return;
      } else {
          // otherwise, close the current open content and open the clicked content
          if (activeContent) {
            activeTrigger.classList.remove('active');
            activeContent.classList.remove('active');
            slideUp(activeContent, 300);
          }

        parent.classList.add('active');
        content.classList.add('active');
        slideDown(content, 300);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-with-slider"] && !Shopify.designMode) return;
  try {
    
    const textWithSlider = new Swiper('.text-with-slider', {
      slidesPerView: 1,
      loop: false,
      spaceBetween: 0,
      autoplay: false,
      speed: 500,
      autoHeight: true,
      pagination: {
                el: ".text-with-slider__swiper-pagination",
                clickable: true,
            },
      navigation:  {
        nextEl: '.text-with-slider__next .swiper-button-next',
        prevEl: '.text-with-slider__prev .swiper-button-prev',
      },
    });

  } catch(e) { console.error(e); }
})();
})();
